import React from 'react';
import { motion } from 'framer-motion';
export function PollBar({
  percentage,
  text
}: {
  percentage: number;
  text: string;
}) {
  return <div className="mb-8" data-id="element-111">
      <p className="text-sm font-medium text-slate-300 mb-3" data-id="element-112">{text}</p>
      <div className="h-2 w-full bg-white/10 rounded-full overflow-hidden flex" data-id="element-113">
        <motion.div initial={{
        width: 0
      }} animate={{
        width: `${percentage}%`
      }} transition={{
        duration: 1,
        ease: 'easeOut',
        delay: 0.2
      }} className="h-full bg-[#4B9FE1] rounded-full" data-id="element-114" />
      </div>
    </div>;
}